import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HoustonIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13.0121 8.54004L15.5791 11.3324C15.7798 11.5081 15.9407 11.7246 16.0509 11.9676C16.1611 12.2105 16.2182 12.4742 16.2182 12.741V14.076C16.2182 14.3243 16.1196 14.5624 15.944 14.738C15.7684 14.9135 15.5303 15.0122 15.282 15.0122H12.6738",
                fill: "#7CA32B"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.20611 8.54004L3.6391 11.3324C3.43837 11.5081 3.27751 11.7246 3.16728 11.9676C3.05706 12.2105 3.00003 12.4742 3 12.741V14.076C3 14.3243 3.09863 14.5624 3.2742 14.738C3.44977 14.9135 3.68789 15.0122 3.93618 15.0122H6.54438",
                fill: "#7CA32B"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.74463 6.7426L7.21662 16.5725H11.9365L12.4085 6.7426C12.4085 5.19166 11.1404 2.52979 9.57657 2.52979C8.01271 2.52979 6.74463 5.19166 6.74463 6.7426ZM9.5766 8.14695C10.4455 8.14695 11.1499 7.44838 11.1499 6.58665C11.1499 5.72492 10.4455 5.02635 9.5766 5.02635C8.70769 5.02635 8.0033 5.72492 8.0033 6.58665C8.0033 7.44838 8.70769 8.14695 9.5766 8.14695Z",
                fill: "#7CA32B"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.05957 2.01489H6.08937",
                stroke: "#7CA32B",
                strokeWidth: "0.514899",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.57471 1.5V2.5298",
                stroke: "#7CA32B",
                strokeWidth: "0.514899",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.51514 5.10425H4.54494",
                stroke: "#7CA32B",
                strokeWidth: "0.514899",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.02979 4.58936V5.61915",
                stroke: "#7CA32B",
                strokeWidth: "0.514899",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.14287 17.7618L8.19889 12.0979C8.17273 11.9409 8.29375 11.7981 8.45283 11.7981H10.9344C11.0935 11.7981 11.2145 11.9409 11.1884 12.0979L10.2444 17.7618C10.2237 17.8859 10.1163 17.9769 9.99043 17.9769H9.39682C9.27097 17.9769 9.16356 17.8859 9.14287 17.7618Z",
                fill: "#7CA32B",
                stroke: "#7CA32B",
                strokeWidth: "0.514899"
            })
        ]
    });
